import React, { Dispatch, SetStateAction, useEffect } from 'react'
import { CompanyInfo, profileElement } from '.'
import { useNavigate } from 'react-router-dom'
import { FormControl, InputLabel, MenuItem, Pagination, Select, TablePagination, Typography } from '@mui/material';
import TableViewCommon from '../../../molecules/table-view-common';
import TableCellsRow from './profile-table-cell';

interface CompanyInfoPageContentProps {
    data: profileElement[],
    setData: Dispatch<SetStateAction<profileElement[]>>,
    refetch: (a: number, b: number) => void,
    companyInfo: CompanyInfo | null,
    totalResults: number,
    totalPages: number,
}
const headCells = [
    {
        id: "id",
        label: "ID",
        numeric: true,
        disablePadding: false,
        isSort: false,
    },
    {
        id: "name",
        label: "Name",
        numeric: false,
        disablePadding: false,
        isSort: false,
    }
];
const CompanyInfoPageContent = ({ data, setData, refetch, companyInfo, totalPages, totalResults }: CompanyInfoPageContentProps) => {
    const [page, setPage] = React.useState(1);
    const [rowsPerPage, setRowsPerPage] = React.useState(50);
    const [forceReload, setForceReload] = React.useState(false);
    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number,
    ) => {
        setForceReload(true);
        setPage(newPage + 1);
    };

    const handleChangeRowsPerPage = (
        event: any,
    ) => {
        setForceReload(true);
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(1);
    };
    useEffect(() => {
        if (forceReload) {
            refetch(rowsPerPage, page);
            setForceReload(false);
        }
    }, [forceReload])
    const handleClick = async (e: any, row: any) => {
        window.open(`/layout/expert-profile?id=${row.id}&page=1`, '_blank');
    }
    return (
        <div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ marginBottom: "1rem" }}>
                <Typography variant='h5' >
                    {companyInfo?.name} ({companyInfo?.id})
                </Typography>
            </div>
            {data.length === 0 && <Typography variant="h6" style={{ textAlign: "center" }}>No Data Found</Typography>}
            {data.length > 0 &&
                <div style={{ display: "flex", justifyContent: "center", overflowY: "auto", backgroundColor: "white" }}>
                    <TableViewCommon<profileElement>
                        rows={data}
                        totalSelected={0}
                        title=""
                        headCells={headCells}
                        isSelected={false}
                        selectAllowed={(row) => false}
                        handleTableRowClick={handleClick}
                        tableCells={(row, labelId, isSelected) => (
                            <TableCellsRow
                                key={row.id}
                                row={row}
                                labelId={labelId}
                                isSelected={isSelected}
                            />
                        )}
                        isItemSelected={(id) => false}
                        handleSelectAllClick={(e) => { }}
                        containerSx={{ maxHeight: "calc(100dvh - 255px)" }}
                        outerBoxSx={{ mt: "5px" }}
                        paperSx={{ borderRadius: "2px" }}
                        rowsPerPageDefault={4001}
                        hidePagination={true}
                    />
                </div>
            }
            <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", backgroundColor: "white", width: "100%", borderTop: "1px solid #e0e0e0" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", padding: "0.5rem", paddingRight: "2rem" }}>
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={(e, value) => handleChangePage(null, value - 1)}
                    />
                    <div style={{ display: "flex", justifyContent: "center", gap: "1rem" }}>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "0.5rem" }}>
                            <Typography variant="body1">
                                Rows Per Page:
                            </Typography>
                            <FormControl sx={{ m: 1 }} variant="standard">
                                <Select
                                    value={rowsPerPage}
                                    onChange={(e) => handleChangeRowsPerPage(e)}
                                >
                                    <MenuItem value={50}>50</MenuItem>
                                    <MenuItem value={100}>100</MenuItem>
                                    <MenuItem value={200}>200</MenuItem>
                                    <MenuItem value={400}>400</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "0.5rem" }}>
                            <Typography variant="body1">
                                Total Results: {totalResults}
                            </Typography>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CompanyInfoPageContent